import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { IFetchError } from "../../../../../types";
import { Toast } from "../../../../../utils";
import Fetch from "../../../../../utils/fetch";

type PaymentTypes = {
  id: number;
  name: string;
  code_name: string;
  service_charge: number;
}[];

export function usePaymentTypes() {
  const navigate = useNavigate();
  return useQuery(
    ["payment_types"],
    async () =>
      await Fetch<PaymentTypes>({
        method: "POST",
        url: process.env.REACT_APP_BACKEND_URL + "/api/dropdowns/payment/types",
        navigate,
      }),
    {
      onError: (error) =>
        Toast.fire({
          icon: "error",
          title: (error as IFetchError).message,
          position: "bottom-left",
          showCloseButton: true,
        }),
    }
  );
}
